import { MonetizationType } from '@/@types/graphql-types';
import { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import { ModalHelper } from '@/helpers/vfm/modal-helper';

import { TitleDetail } from '@/interfaces/title-details-graphql';
import { WatchNowOfferFragment } from '@/pages/graphql/fragments/WatchNowOffer.fragment';
import { S72ModalContexts } from '@/features/jwtv-titles-rental/tracking';

const jwtvTitleRentalModal = () => import('@/features/jwtv-titles-rental/components/JwtvTitleRentalModal.vue');

type JWTVModalProps = (
	| {
			title: TitleDetail;
			offer: TitleOfferFragment | WatchNowOfferFragment;
			overrideSuccessUrl?: string | null;
			promoCode?: string;
			titleSlug?: string;
			isFallback?: boolean;
	  }
	| {
			finalUrl: string;
	  }
) & {
	additionalContexts?: S72ModalContexts;
};

export async function openJwTvRentalModal(payload: { modalProps: JWTVModalProps; onClose?: () => void }) {
	await ModalHelper.openModal(
		jwtvTitleRentalModal,
		{
			...payload.modalProps,
		},
		{
			cssClass: 'account-modal',
			id: 'jwtv-rent-modal',
		},
		undefined,
		undefined,
		payload.modalProps.additionalContexts,
		() => {
			payload.onClose?.();
		}
	);
}

export function isJwtvTvodOffer(offer: TitleOfferFragment | WatchNowOfferFragment): boolean {
	const isJustWatchTvPackage = offer?.package.shortName === 'jwt';
	const isBuyOrRent = [MonetizationType.Buy, MonetizationType.Rent].includes(offer.monetizationType);
	const isTvStreamUrl = !!offer.streamUrl?.includes('tv.justwatch.com');

	return isJustWatchTvPackage && (isBuyOrRent || isTvStreamUrl);
}
